import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var E = Object.defineProperty,
    P = Object.defineProperties;
var Q = Object.getOwnPropertyDescriptors;
var h = Object.getOwnPropertySymbols;
var y = Object.prototype.hasOwnProperty,
    C = Object.prototype.propertyIsEnumerable;

var S = function S(e, o, t) {
  return o in e ? E(e, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : e[o] = t;
},
    s = function s(e, o) {
  for (var t in o || (o = {})) {
    y.call(o, t) && S(e, t, o[t]);
  }

  if (h) {
    var _iterator = _createForOfIteratorHelper(h(o)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var t = _step.value;
        C.call(o, t) && S(e, t, o[t]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    F = function F(e, o) {
  return P(e, Q(o));
};

var f = function f(e, o) {
  var t = {};

  for (var a in e) {
    y.call(e, a) && o.indexOf(a) < 0 && (t[a] = e[a]);
  }

  if (e != null && h) {
    var _iterator2 = _createForOfIteratorHelper(h(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var a = _step2.value;
        o.indexOf(a) < 0 && C.call(e, a) && (t[a] = e[a]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return t;
};

import n, { useReducer as T } from "react";
import { Formik as b, Form as A, useFormikContext as x } from "formik";
import g from "classnames";
import { useOnClickOutside as B } from "../hooks";
import { Modal as N, ModalHeader as O, ModalActions as I } from "../modal";
import { formReducer as w } from "./Form.helpers";
import "./form.css";
import { Button as D } from "../buttons/Button";
import { ButtonPrimary as H } from "../buttons/ButtonPrimary";

var L = function L(v) {
  var i = v,
      e = i.className,
      o = i.state,
      t = i.dispatch,
      a = i.withoutFormElement,
      r = i.confirmUnsavedChanges,
      m = i.unsavedChangesConfig,
      c = f(i, ["className", "state", "dispatch", "withoutFormElement", "confirmUnsavedChanges", "unsavedChangesConfig"]);
  var u = x();
  return B(function (l) {
    !r || !l.target || !o.shouldCheckForUnsavedChanges || !u.dirty || (l.preventDefault(), t({
      name: "openModal",
      payload: "unsavedChangesModal"
    }), t({
      name: "setCapturedUnsavedChangesEvent",
      payload: l
    }));
  }, m.containerQuerySelectorAll ? "".concat(m.containerQuerySelectorAll, ", #lc-unsaved-changes-modal") : void 0, m.targetQuerySelector, "[data-lc-trigger-unsaved-changes]"), a ? n.createElement("div", s({
    className: g(e, "lc-form")
  }, c)) : n.createElement(A, s({
    className: g(e, "lc-form")
  }, c));
};

function le(v) {
  var i = v,
      e = i.className,
      o = i.children,
      t = i.withoutFormElement,
      a = i.confirmUnsavedChanges,
      _i$unsavedChangesConf = i.unsavedChangesConfig,
      r = _i$unsavedChangesConf === void 0 ? {} : _i$unsavedChangesConf,
      m = i.formConfig,
      c = f(i, ["className", "children", "withoutFormElement", "confirmUnsavedChanges", "unsavedChangesConfig", "formConfig"]);
  r = s({
    targetQuerySelector: 'a:not([href="#"]), button, .navbar-back'
  }, r);
  var u = ["form", ".snackbar", "[role=dialog]"];
  (r == null ? void 0 : r.containerQuerySelectorAll) && (u[0] = r.containerQuerySelectorAll), r.containerQuerySelectorAll = u.join(", ");

  var _T = T(w, {
    activeModal: "none",
    shouldCheckForUnsavedChanges: !0
  }),
      _T2 = _slicedToArray(_T, 2),
      d = _T2[0],
      l = _T2[1],
      M = function M() {
    l({
      name: "closeModal"
    }), l({
      name: "setShouldCheckForUnsavedChanges",
      payload: !1
    }), setTimeout(function () {
      l({
        name: "setShouldCheckForUnsavedChanges",
        payload: !0
      });
    }, 500);
  },
      U = function U(p) {
    if (l({
      name: "closeModal"
    }), l({
      name: "setShouldCheckForUnsavedChanges",
      payload: !1
    }), d.capturedUnsavedChangesEvent && r.targetQuerySelector) {
      var k = d.capturedUnsavedChangesEvent.target.closest(r.targetQuerySelector);
      k && k.click();
    }

    p.resetForm(), setTimeout(function () {
      l({
        name: "setShouldCheckForUnsavedChanges",
        payload: !0
      });
    }, 500);
  };

  return n.createElement(b, F(s({}, c), {
    initialStatus: F(s({}, c.initialStatus), {
      formConfig: m
    })
  }), function (p) {
    return n.createElement(L, {
      className: e,
      state: d,
      dispatch: l,
      withoutFormElement: t,
      confirmUnsavedChanges: a,
      unsavedChangesConfig: r
    }, n.createElement(n.Fragment, null, o(p), n.createElement(N, s({
      id: "lc-unsaved-changes-modal",
      isOpen: d.activeModal === "unsavedChangesModal",
      closeButton: !1
    }, r == null ? void 0 : r.modalProps), n.createElement(O, {
      title: "You have unsaved changes!"
    }), n.createElement("p", {
      className: "text"
    }, "Click continue to abandon your changes and continue on."), n.createElement(I, null, n.createElement("div", {
      className: "flex-spacer"
    }), n.createElement(D, {
      onClick: M
    }, "Cancel"), n.createElement(H, {
      onClick: function onClick() {
        return U(p);
      }
    }, "Continue")))));
  });
}

export { le as Form };